module.exports = __webpack_public_path__ + "static/img/huikuanBg.f9fbe50b.png";